// angular
// 	.module("HeroPRO")
// 	.controller("PaymentInstructionsController", paymentInstructionsController);

import _ from 'lodash';
import './paymentInstructions.scss';

/* @ngInject */
export default function paymentInstructionsController($scope, FRClosingFactory) {
    const vm = this;
    vm.isCollapsed = true;
    vm.projectAdvanceData = {};
    vm.fundingRequest = [];
    vm.totalLabel = 'Total';

    vm.lateText = 'PA Delinquent';

    
    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */


    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */


    function init() {
        FRClosingFactory.getFundingRequestClosingPromise().then(() => {
            vm.fundingRequest = FRClosingFactory.getFundingRequest();
            vm.projectDetails = FRClosingFactory.getProjectDetails();
            if (vm.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId === 11) {
                vm.projectAdvanceData = FRClosingFactory.getProjectAdvanceDetails();
                if (vm.projectAdvanceData === undefined) {
                    vm.projectAdvanceData = {};
                }
            }
            const contractorDisbursement = _.find(FRClosingFactory.getPaymentInstructions().newDisbursements, disbursement => disbursement.PayeeType === 'Contractor');
            if (contractorDisbursement) {
                vm.totalLabel = 'Payment to Contractor';
            }
        });
    }

    $scope.$watch(() => FRClosingFactory.getPaymentInstructionsConfirmed(), (newValue) => {
        vm.isCollapsed = newValue;
    });

    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/appDetail/paymentInstructions/paymentInstructionsController.js